import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import { SvgIcon } from 'components/SvgIcon';
import Grid from '@material-ui/core/Grid';
import Translate from 'components/Translate';
import ModalDoubts from 'components/ThankYouPage/ModalDoubts';
import { getCdnImage } from 'functions';

const style = require('./cardProducer.css');

interface IProps {
  infos: IThankYouPage;

}

export default class CardProducer extends BaseComponent<any, IProps> {

  render() {

    if (!this.props) {
      return <div />;
    }

    return (
      <div className={style.component}>
        <div className='chk-cardProducer__header'>
          <Grid
            container
            spacing={16}
            alignItems={'center'}
            justify={'flex-start'}
            direction={'row'}
          >
            <Grid item className='chk-grid' xs={12} sm={1}>
              <img
                className='chk-image'
                src={getCdnImage(this.props.infos.imgProduct)}
              />
            </Grid>
            <Grid item className='chk-grid' xs={12} sm={8}>
              <div className={'chk-label theme-label'} id='thankyou-title'>
                <span>
                  <SvgIcon name='check' />
                </span>
                &nbsp; {this.props.infos.isFree ?
                  <Translate term='Sucesso! Verifique seu e-mail!' />
                  : <Translate term='Obrigado pela Compra!' />
                }
              </div>
              <div className={'chk-paragraph theme-label'} id='thankyou-text'>
                <Translate term={'Enviamos instruções para acessar seu Conteúdo no email '} />
                <span className='chk-email'>{this.props.infos.userEmail || 'utilizado na compra'}</span>
                <Translate term={'. Se não encontrar nos próximos minutos, verifique também sua caixa de Lixo Eletrônico.'} />
              </div>
              <div className='doubts'>
                <Translate term={'Caso ainda tenha alguma dúvida'} />
                <div className='click-here'><ModalDoubts name={` clique aqui`} infos={this.props.infos} showProducerContact /></div>
              </div>
            </Grid>
            <Grid item className='chk-grid' xs={12} sm={3}>
              <div className='chk-btn-download' id='thankyou-confirmation-message'>
                {this.props.infos.isFree ? <Translate term={'você receberá um e-mail quando seu conteúdo estiver disponível'} />
                  : <Translate term={'Seu pagamento será processado e você receberá um e-mail quando seu conteúdo estiver disponível'} />}
              </div>
            </Grid>
          </Grid>
        </div>
        {
          this.props.infos.producerIframe && this.props.infos.displayThankyou ?
            <iframe
              src={this.props.infos.producerIframe}
              name='iframe-producer'
              className='chk-boletoProducer__thankouPageiFrame'
            /> : null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/CardPage/CardProducer/index.tsx